import type { OrgLocationEntity } from '../entities/OrgLocationEntity.js';
import type { IOrgProjectLocationRepository } from '../repositories/IOrgProjectLocationRepository.js';

interface Deps { orgProjectLocationRepository: IOrgProjectLocationRepository; }

export function createGetOrgLocationUseCase({ orgProjectLocationRepository }: Deps) {
  return async function getOrgLocation(orgId: string, locationId: string): Promise<OrgLocationEntity | null> {
    return orgProjectLocationRepository.getByOrgLocation(orgId, locationId);
  };
}
